/**
 * Keep in sync with backend config/staff_permissions.php
 * and StaffPermissionRegistry (orders.view_others / change_others are orders-only).
 */
export const STAFF_PERMISSION_SUBJECTS = {
  orders: 'Orders',
  products: 'Products',
  product_categories: 'Product categories',
  services: 'Services',
  service_categories: 'Service categories',
  stock_locations: 'Stock locations',
  customers: 'Customers',
}

export const STAFF_PERMISSION_ABILITIES = {
  create: 'Create',
  change: 'Change',
}

export function createEmptyStaffPermissions() {
  return Object.keys(STAFF_PERMISSION_SUBJECTS).reduce((matrix, subject) => {
    matrix[subject] = { create: false, change: false }
    if (subject === 'orders') {
      matrix[subject].view_others = false
      matrix[subject].change_others = false
    }
    return matrix
  }, {})
}

export function staffPermissionSubjectLabel(subject, companyPurpose = window.companyPurpose) {
  if (subject === 'orders') {
    return companyPurpose !== 'rent' ? 'Orders' : 'Bookings'
  }
  if (subject === 'products') {
    return companyPurpose !== 'rent' ? 'Products' : 'Units'
  }
  if (subject === 'product_categories') {
    return companyPurpose !== 'rent' ? 'Product categories' : 'Unit categories'
  }
  return STAFF_PERMISSION_SUBJECTS[subject] || subject
}
